import clsx from 'clsx/lite'
import type { ReactNode } from 'react'

export function Card({ children, className }: { children: ReactNode, className?: string }) {
  return (
    <div className={clsx('rounded-md shadow-[0_4px_10px_6px_rgba(0,0,0,0.06),0_2px_3px_0_rgba(0,0,0,0.12)]', className)}>
      {children}
    </div>
  )
}
